import React from 'react';
import SbEditable from 'storyblok-react';
import CustomOrderedTeam from './CustomOrderedTeam';

const CoreTeam = ["George McGraffin", "Peter Taylor", "Jonathan Bentley", "Elaine Lucas", "Geoffroy Delmas"];


const WithLargeImages = ({ blok }) => {
  return (
      <CustomOrderedTeam orderArray={CoreTeam} blok={blok} />
  );
};

export default WithLargeImages;
